import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FormComponent } from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';
import { Titles } from './title-needs-name-validator.directive';

export interface NasdaqAgreementFormModel {
  professionalIndicator: boolean
  clientName: string
  signature: string
  agentName: string
  subscriberAgentTitle: string
  titles: { [key in Titles]: boolean }
}

@Component({
  selector: 'td-wb-nasdaq-agreement',
  templateUrl: './nasdaq-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NasdaqAgreementComponent extends AgreementsDateBaseDirective {

  @ViewChild(FormComponent) form: FormComponent;
  @ViewChild('btn') btn: ElementRef;

  collapsed: boolean = false;

  formModel: NasdaqAgreementFormModel = {
    professionalIndicator: undefined,
    clientName: '',
    signature: '',
    agentName: '',
    subscriberAgentTitle: '',
    titles: {
      CEO: false,
      COO: false,
      DIRECTOR: false,
      PRESIDENT: false,
      SVP: false,
      VP: false
    }
  };

  trySubmitAndReturnModel(): NasdaqAgreementFormModel {
    return super.trySubmit(this.form) ? this.formModel : undefined;
  }
}
